export default __webpack_public_path__ + "static/media/image.ideal-soft-global-pvt-ltd.b4709b87.png";